import { styled } from 'styled-components'

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 0;
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-feature-settings: 'case' on;
  font-size: 18px;
  font-weight: 500;
  line-height: 160%;
  color: ${({ theme }) => theme.colors.black};
`

export const OriginalPrice = styled.span`
  text-decoration: line-through;
  color: ${({ theme }) => theme.colors.grayDark};
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: ${({ theme }) => theme.colors.grayDark};
  display: flex;
  align-items: center;
  outline: none;
  -webkit-tap-highlight-color: transparent;

  svg {
    width: 24px;
    height: 24px;
  }
`
